import { Box, useMediaQuery } from "@material-ui/core";
import React, { MutableRefObject, useState } from "react";
import TextField from "../../../design-system/molecules/textField";
import Autocomplete from "components/design-system/molecules/Autocomplete";
import { useQuery } from "react-query";
import { Brand } from "types/brand";
import { DetailsDefaultValue } from "components/repairFunnel/steps/repairFunnelMalfunctionStep/RepairFunnelMalfunctionsDetail";
import theme from "theme";

interface IdentifyMachineProps {
  defaultValues?: DetailsDefaultValue;
  onBlurNotExistingBrand: (value: React.ChangeEvent<HTMLInputElement>) => void;
  onUpdate: (value: React.ChangeEvent<HTMLDataListElement>) => void;
}

const BrandNameAutocomplete: React.FunctionComponent<IdentifyMachineProps> = ({
  defaultValues,
  onBlurNotExistingBrand,
  onUpdate,
}) => {
  const OPTION_OTHER = ["Autre"];
  const BRAND_UNKNOWN_NAME = "otherBrand";

  const [brandIsUnknown, setBrandIsUnknown] = useState(false);
  const isTablet = useMediaQuery(theme.breakpoints.down("sm"));

  const getBrandListDropdown = (brands: Brand[]): string[] =>
    brands
      .map((brand) => brand.name)
      .sort()
      .concat(OPTION_OTHER);

  const { data: brands } = useQuery<Brand[], any, string[]>(["product/brands"], {
    initialData: [],
    select: getBrandListDropdown,
  });

  const autoCompleteRef: MutableRefObject<HTMLElement> = React.useRef();

  const scrollToAutoComplete = () => {
    const autoCompletePosition = autoCompleteRef.current.getBoundingClientRect();
    autoCompleteRef.current.scrollIntoView();
    window.scrollBy(0, -(autoCompletePosition.height + 20));
  };
  const updateBrand = async (selected: React.ChangeEvent<HTMLDataListElement>) => {
    if (OPTION_OTHER.includes(selected.target.textContent)) {
      setBrandIsUnknown(true);
      const inputElements = Array.from(document.getElementsByTagName("input"));
      inputElements.find((element) => element.name === BRAND_UNKNOWN_NAME).focus();
    } else {
      onUpdate(selected);
      setBrandIsUnknown(false);
    }
  };
  return (
    <Box mt={5}>
      <Box mb={2}>
        <Autocomplete
          options={brands}
          alwaysPresentOptions={OPTION_OTHER}
          label="Marque de l'appareil"
          onOptionSelected={updateBrand}
          onFocus={scrollToAutoComplete}
          reference={autoCompleteRef}
          defaultValue={defaultValues?.brand}
        />
      </Box>
      <Box mb={2} hidden={!brandIsUnknown}>
        <TextField
          label={isTablet ? "Marque" : "Autre marque"}
          fullWidth
          onBlur={onBlurNotExistingBrand}
          defaultValue={defaultValues?.brand}
          inputProps={{ maxLength: 64 }}
          name={BRAND_UNKNOWN_NAME}
        />
      </Box>
    </Box>
  );
};

export default BrandNameAutocomplete;
